let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("4lvCC")]).then(() => parcelRequire('3hooO'));